import { Button } from 'shared-ui';
import { Headset, Mail } from 'lucide-react';

import { useAppConfig } from '@/config/AppConfigContext';

export function HelpContent() {
    const { supportEmail, supportPhone } = useAppConfig();

    return (
        <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
                <p className="text-foreground text-base leading-6 font-bold tracking-normal">
                    Contact a member of the Origin team
                </p>
                <p className="text-muted-foreground text-sm">
                    We&apos;re here to help. Email us anytime and we&apos;ll respond as soon as possible, or call our
                    support team Monday to Friday, 9–5pm.
                </p>
            </div>

            <div className="flex flex-col gap-2">
                <Button
                    className="h-10 w-full"
                    disabled={!supportEmail}
                    onClick={() => {
                        window.location.href = `mailto:${supportEmail}`;
                    }}
                >
                    <Mail className="size-4" />
                    Email Origin
                </Button>

                <Button
                    variant="outline"
                    className="h-10 w-full"
                    disabled={!supportPhone}
                    onClick={() => {
                        window.location.href = `tel:${supportPhone}`;
                    }}
                >
                    <Headset className="size-4" />
                    Call Origin
                </Button>
            </div>
        </div>
    );
}
